var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("validation.errorHeader")))]),
    _vm._v(" "),
    _c("div", { staticClass: "ct-card" }, [
      _c("section", { staticClass: "top-margin" }, [
        _vm.showMessage
          ? _c(
              "div",
              {
                staticClass: "ct-text alert alert-danger",
                attrs: { role: "alert" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t(_vm.messageKey)) +
                    "\n            "
                )
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e90879a0", { render: render, staticRenderFns: staticRenderFns })
  }
}